"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.doWithBackoff = void 0;
const time_1 = require("./time");
function doWithBackoff(action, backoffPolicy) {
    return __awaiter(this, void 0, void 0, function* () {
        let delay = backoffPolicy.min;
        for (let i = 0; i < backoffPolicy.attempts; i++) {
            try {
                return yield action();
            }
            catch (e) {
                yield (0, time_1.sleep)(delay);
                delay = Math.min(delay * backoffPolicy.scalar, backoffPolicy.max);
            }
        }
    });
}
exports.doWithBackoff = doWithBackoff;
